import _ from 'lodash';
import { MutationTree } from 'vuex';
import { FiltersEventsRegional, FiltersEventsRegionalState } from '@/models/states/filters-state.model';

export const mutations: MutationTree<FiltersEventsRegionalState> = {
  onUpdateFilters(state, payload: FiltersEventsRegional) {
    state.filters = _.extend({}, state.filters, payload);
  },
};
